export function scrollToTop() {
  let tgt;
  if ('scrollingElement' in document) {
    tgt = document.scrollingElement;
  } else {
    tgt = (document as any).documentElement;
  }
  tgt.scrollTop = 0;
}
